import { useOrganizationStorage } from '../../../../../../AppClients';
import { Panel } from '../../../../../../ui/components/deprecated/Panel';
import { useContactManagementTranslation } from '../../../../../../ui/hooks';
import { AppPageHeader2 } from '@juvare/common-web-ui/AppPageHeader2';
import { GlobalLoader } from '@juvare/common-web-ui/GlobalLoader';
import { NavigationContext } from '@juvare/common-web-ui/NavigationContext';
import { showInfoSnackbar } from '@juvare/common-web-ui/SnackbarHelper';
import { usePlatformLoader } from '@juvare/platform-sdk-react/ui/hooks';
import { Box } from '@mui/material';
import React, { useContext } from 'react';
import { useNavigate, useParams } from 'react-router';
import { useOrganizationSections } from '../../../hooks/useOrganizationSections';
import { OrganizationSectionComponent } from '../../OrganizationSectionComponent';
export const CreateOrganization = () => {
    const { t } = useContactManagementTranslation();
    const organizationStorage = useOrganizationStorage();
    const navigationContext = useContext(NavigationContext);
    const navigate = useNavigate();
    const { onReload } = usePlatformLoader({});
    const params = useParams();
    const { sections, isLoading } = useOrganizationSections();
    const basicInfoSection = sections === null || sections === void 0 ? void 0 : sections.find((s) => s.columns.key === 'basicInfo');
    const parentId = params.parentId;
    if (basicInfoSection) {
        return (React.createElement(Panel, { header: React.createElement(AppPageHeader2, { title: t('panels.organizations.title'), subTitle: t('common.new'), onBack: () => navigationContext.navigate(() => {
                    navigate(-1);
                }, true) }), contentWidth: 800, contentPadding: 2, scrollable: true },
            React.createElement(OrganizationSectionComponent, { section: basicInfoSection, showSubmitButton: true, parentId: parentId, onChanged: (changed, submit) => navigationContext.setChanged(t('common.saveChanges'), submit), onSubmit: (data) => organizationStorage.post({
                    action: 'create',
                    data: Object.assign({}, data),
                    parentId: parentId !== null && parentId !== void 0 ? parentId : undefined,
                }), onSubmitSuccess: (data, response) => {
                    navigationContext.clearChanged();
                    showInfoSnackbar({ message: t('common.saved'), autoHideDuration: 2000 });
                    onReload();
                    const searchParams = new URLSearchParams();
                    let orgId = response.id;
                    if (parentId) {
                        orgId += `_${parentId}`;
                    }
                    // Child organizations have uniqueId built from orgId_ParentId in order to ensure uniqueness in the table
                    searchParams.set('id', orgId);
                    navigationContext.navigate(() => {
                        navigate({ pathname: '..', search: searchParams.toString() });
                    });
                } })));
    }
    else if (isLoading) {
        return React.createElement(GlobalLoader, { message: t('common.loading') });
    }
    else {
        return React.createElement(Box, null, "Basic Information section was not found");
    }
};
